import { Directive, HostListener, Input } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { EnumApiModel } from '../models/enumApiModel';

@Directive({
    selector: '[appUniqueColumnValue]',
    standalone: false
})
export class UniqueColumnValueDirective {
  @Input() columnDataSource: EnumApiModel[];

  constructor(private readonly host: DxDataGridComponent) {}

  @HostListener('onEditorPreparing', ['$event']) onEditorPreparing(e) {
    if (e.parentType === 'dataRow' && e.dataField === 'typeDescription') {
      const gridDataSource = this.host.dataSource as any[];
      const usedValues = gridDataSource
        .filter(r => r !== gridDataSource[e.row.dataIndex])
        .filter(r => r !== undefined)
        .map(t => t.typeDescription);
      e.editorOptions.dataSource = this.columnDataSource.filter(t => !usedValues.includes(t.description));
    }
  }
}
